import { Suspense, type ComponentType } from 'react';
import SuspenseFallback from '../suspense-fallback/suspense-fallback';

type RouteSuspenseProps<P extends object = Record<string, never>> = {
  component: ComponentType<P>;
  suspenseFallback?: React.ReactNode;
} & P;

export default function RouteSuspense<P extends object>({
  component: Component,
  suspenseFallback = <SuspenseFallback />,
  ...props
}: RouteSuspenseProps<P>) {
  return (
    <Suspense fallback={suspenseFallback}>
      <Component {...(props as P)} />
    </Suspense>
  );
}
